import React, { Component } from 'react';
import PropTypes from 'prop-types';

class InputBlock extends Component {

  blockClassNames() {
    const classes = ["input-block"];
    if (this.props.className) classes.push(this.props.className);
    if (this.props.size) classes.push(`-${this.props.size}`);
    return classes.join(" ");
  }

  render() {
    return (
      <div className={this.blockClassNames()}>
        {this.props.children}
      </div>
    )
  }

}

InputBlock.propTypes = {
  children:   PropTypes.node,
  size:       PropTypes.string,
  className:  PropTypes.string,
};

export default InputBlock;
